// only commons scripts and styles
import '@/less/new/desktop/common.less';

// custom libs
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg.min';
import 'lazysizes/plugins/bgset/ls.bgset.min';
import 'simplebar';

import init from '@/js/helpers/init';

// widgets
import Minimize from '@/js/widget/Minimize';
import More from '@/js/widget/More';
import Catalog from '@/js/widget/new/Catalog';
import ToggleNew from '@/js/widget/new/Toggle.js';
// vue components
import PortalsTarget from '@/js/vue/PortalsTarget';
import AuthButtonsD from '@/js/vue/Auth/AuthButtonsD';
import CallOrderD from '@/js/vue/Callback/buttons/desktop/CallOrderHeaderDNew';
import ChooseCity from '@/js/vue/ChooseCity';
import PartnerLink from '@/js/vue/PartnerLink/PartnerLink';
import SearchLineD from '@/js/vue/SearchLine/SearchLineD';
import PersonalRecommendationPromoMenuItem from '@/js/vue/PersonalRecommendation/PersonalRecommendationPromoMenuItem';
import PersonalRecommendationHeaderItem from '@/js/vue/PersonalRecommendation/PersonalRecommendationHeaderItem';

document.addEventListener('DOMContentLoaded', async () => {
  const { default: RenderWidgetHelper } = await import(/* webpackChunkName: "RenderWidgetHelper" */'@/js/helpers/RenderWidgetHelper');
  const { default: ComponentWidgets } = await import(/* webpackChunkName: "ComponentWidgetsD" */'@/js/vue/GetWidgetsDNew/ComponentWidgetsD');
  window.RenderWidgetHelper = new RenderWidgetHelper('.js-render-widget', ComponentWidgets);

  if (document.querySelector('.js-product-buttons-block')) {
    import(/* webpackChunkName: "ProductButtonsBlock" */'@/js/vue/ProductNew/ProductButtonsBlock')
      .then(({ default: ProductButtonsBlock }) => {
        init('.js-product-buttons-block', ProductButtonsBlock, 'vue');
      });
  }

  if (document.querySelector('.js-logout')) {
    import(/* webpackChunkName: "LogOutLink" */'@/js/widget/new/LogOutLink')
      .then(({ default: LogOutLink }) => {
        init('.js-logout', LogOutLink, 'widget', 'LogOutLink');
      });
  }

  init('.js-more', More, 'widget', 'More');
  init('.js-minimize', Minimize, 'widget', 'Minimize');
  init('.js-catalog', Catalog, 'widget', 'Catalog');
  init('.js-toggle', ToggleNew, 'widget', 'ToggleNew');

  init('.js-search-line-d', SearchLineD, 'vue');
  init('.js-portals-target', PortalsTarget, 'vue');
  init('.js-auth-buttons', AuthButtonsD, 'vue');
  init('.js-call-order-new', CallOrderD, 'vue');
  init('.js-choose-city-d', ChooseCity, 'vue');
  init('.js-partner-link-vue', PartnerLink, 'vue');
  init('.js-promo-menu-personal-recommendation', PersonalRecommendationPromoMenuItem, 'vue');
  init('.js-personal-header-recommendation', PersonalRecommendationHeaderItem, 'vue');
});
